import api from './client';

/**
 * 이미지 파일을 서버에 업로드하고 접근 가능한 URL을 반환합니다.
 * @param {File} file - 업로드할 이미지 파일
 * @returns {Promise<string>} 업로드된 이미지의 URL
 */
export async function uploadImage(file) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await api.post('/api/admin/media/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return res.data.url;
}
